import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const Logout = (props: any) => {
  useEffect(() => {
    localStorage.removeItem("authUser");
    props.history.push("/login");
    const kcUri = `${process.env.REACT_APP_KEYCLOAK_URL}/logout?redirect_uri=${process.env.REACT_APP_DOMAIN}${process.env.REACT_APP_DEFAULT_DIRECT_URI}`;
    window.open(`${kcUri}`, '_self');
  });

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(connect(null, {})(Logout));
